import RestApi from '@utilities/RestApi'
import Axios from 'axios'

import RelationsApi from '@modules/admin/relations/relations.api'
import ConsultationsAuthApiClient from '@modules/auth/auth.api'
import { refreshTokenInterceptor } from '@services/APIInterceptors/refreshTokenInterceptors'
import { AnalyticsApi } from '@modules/admin/analytics/analytics.Api'
import MonitoringApiClient from '@modules/admin/monitoring/monitoring.api'
import AdminRoomApiClient from '@modules/admin/rooms/rooms.Api'
import SchedulesApiClient from '@modules/admin/schedules-legacy/dux/schedules.api'
import CompanyApi from '@modules/admin/companies/company.api'
import UserGroupsApi from '@modules/admin/groups/userGroups.api'
import AreaApi from '@modules/admin/area/area.api'
import SectorsApi from '@modules/admin/sectors/sectors.api'

class ConsultationsSingleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_CONSULTATIONS,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance CONSUTATIONS: ${this.client.defaults.baseURL}`)

    this.client.interceptors.request.use(refreshTokenInterceptor)

    // PROFESIONAL CALLS
    this.auth = new ConsultationsAuthApiClient(this.client)

    //ADMIN CALLS
    this.administrators = new RestApi(this.client, '/admin/v1/administrators')
    this.company = new CompanyApi(this.client, '/admin/v1/companies')
    this.customer = new RestApi(this.client, 'admin/v1/customers')
    this.area = new AreaApi(this.client, '/admin/v2/areas')
    this.sectors = new SectorsApi(this.client, '/admin/v2/sectors')
    this.relations = new RelationsApi(this.client)
    this.teams = new RestApi(this.client, '/admin/v1/teams')
    this.userGroups = new UserGroupsApi(this.client, '/admin/v1/company-groups')
    this.groupsFeeds = new UserGroupsApi(this.client, '/admin/v1/company-groups/feeds')

    this.provider = new RestApi(this.client, '/admin/v1/providers')
    this.professionalRoles = new RestApi(this.client, 'admin/v1/professional/profiles')
    this.adminRooms = new AdminRoomApiClient(this.client)
    this.reviews = new AdminRoomApiClient(this.client)
    this.monitoring = new MonitoringApiClient(this.client)
    this.externalDerivations = new RestApi(this.client, '/admin/v1/derivations')
    this.country = new RestApi(this.client, '/admin/v1/countries')
    this.language = new RestApi(this.client, '/admin/v1/languages')
    this.appRole = new RestApi(this.client, '/admin/v1/app-roles')
    this.role = new RestApi(this.client, '/admin/v1/roles')
    this.reports = new RestApi(this.client, 'admin/v1/report')
    this.derivations = new RestApi(this.client, 'admin/v1/medical-derivation')
    this.analytics = new AnalyticsApi(this.client)
    this.schedules = new SchedulesApiClient(this.client)

    //v2 requests api
    this.companyNew = new CompanyApi(this.client, '/admin/v2/companies')
    this.professional = new RestApi(this.client, '/admin/v2/professionals')
    this.sentence = new RestApi(this.client, '/admin/v2/sentences')
    this.speciality = new RestApi(this.client, '/admin/v2/specialities')

    this.professionalCheckEp = new RestApi(this.client, 'admin/v2/professionals/check')
    this.professionalUpdate = new RestApi(this.client, 'admin/v2/professionals/ep_update')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const Consultations = ConsultationsSingleton.instance
export default Consultations
